<div class="wrapper" *ngIf="form; else spinner"
  [style.backgroundImage]="form.background ? 'url(data:image/jpeg;base64,'+ form.background +')' : null">
  <div class="form-container">
    <div [ngClass]="form.logoPositioning">
      <img *ngIf="form.logo && form.logoPositioning !== logoPosition.NO_LOGO" [src]="logoBase64" alt="Logo" class="logo">
      <h1 class="public-form-header">{{ form.name }}</h1>
    </div>
    <div class="panel">
      <form [formGroup]="formGroup" (ngSubmit)="submitForm()">
        <mat-tab-group [(selectedIndex)]="selectedIndex">
          <mat-tab *ngFor="let tab of tabs; let tabIndex = index;" [label]="tab.tabName">
            <formly-form [form]="formGroup" [model]="model" [fields]="tab.fields" [options]="options[tabIndex]">
            </formly-form>
          </mat-tab>
        </mat-tab-group>
        <div class="buttons">
          <button *ngIf="(tabs?.length - 1) !== selectedIndex" mat-raised-button class="btn btn-primary" mat-raised-button color="primary"
            type="button" (click)="moveToNextTab()">
            {{ 'BUTTON.NEXT' | translate }}
            <mat-icon style="width: 16px;">chevron_right</mat-icon>
          </button>
          <button *ngIf="(tabs?.length - 1) === selectedIndex" mat-raised-button class="btn btn-primary" [disabled]="submitInProgress"
            mat-raised-button color="primary" type="submit">{{ 'BUTTON.SUBMIT' | translate }}</button>
          <button mat-button class="btn" [disabled]="submitInProgress"
            type="button" (click)="clearForm()">{{ 'BUTTON.CLEAR' | translate }}</button>
        </div>
      </form>
    </div>
  </div>
</div>

<ng-template #spinner>
  <div class="spinner">
    <svg width="40px" height="40px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle fill="none" stroke-width="4" stroke-linecap="round" cx="33" cy="33" r="30" class="circle"></circle>
    </svg>
  </div>
</ng-template>

